import React from "react";

const ValueContainer = (props) => {
    const {
        label,
        displayValue,
    } = props;

    return (
        <div className="flex justify-between py-1 px-4">
            <div className="text-neutral-800 text-xs font-['Poppins-Medium'] leading-[30px]">{label}</div>
            <div className="text-zinc-500 text-xs font-['Poppins-Regular'] leading-[30px]">{displayValue}</div>
        </div>
    );
}

export default ValueContainer;